import Instance from "../../../../Axios";

// New Actions for the app

const GetCredPermanentesValidades = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/credPermValidades`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_PERMANENTES_VALIDADES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredPermanentesValidades;
